'use strict';

exports.__esModule = true;

var _SUGGESTION_ICON;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGIcon = require('ad-react-components/lib/SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _propTypes3 = require('../../../../utils/prop-types');

var _genericResult = require('../generic-result');

var _genericResult2 = _interopRequireDefault(_genericResult);

var _suggestion = require('./suggestion.scss');

var _suggestion2 = _interopRequireDefault(_suggestion);

var _suggestionSource = require('../../../../constants/suggestion-source');

var _suggestionSource2 = _interopRequireDefault(_suggestionSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    result: _propTypes3.SuggestionItem.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    index: _propTypes2.default.number.isRequired,
    highlightIndex: _propTypes2.default.number,
    setResultSelection: _propTypes2.default.func.isRequired,
    getContainerRect: _propTypes2.default.func.isRequired,
    scrollIntoView: _propTypes2.default.func.isRequired,
    savedQuery: _propTypes2.default.string.isRequired,
    searchQuery: _propTypes2.default.string.isRequired
};

var defaultProps = {
    highlightIndex: -1
};

var SUGGESTION_ICON = (_SUGGESTION_ICON = {}, _SUGGESTION_ICON[_suggestionSource2.default.AUTOCOMPLETE] = 'search', _SUGGESTION_ICON[_suggestionSource2.default.RECENT] = 'clock', _SUGGESTION_ICON);

// Escapes each special character in the text, by adding a backslash before each special character
var escapeSpecialCharacters = function escapeSpecialCharacters(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

var renderLabelWithHighlightedText = function renderLabelWithHighlightedText(text, highlightText) {
    var escapedHighlightText = escapeSpecialCharacters(highlightText);
    // Split text into parts using highlightText as the delimiter (case insensitive). The delimiter is included
    // on the list of separated text. If highlightText is "abc", then "helloabctestAbcstring" is split into
    // ["hello", "abc", "test", "Abc", "string"].
    var parts = text.split(new RegExp('(' + escapedHighlightText + ')', 'gi')).filter(function (part) {
        return part && part.length;
    }); // Filter out empty strings

    return parts.map(function (part, i) {
        return _react2.default.createElement(
            'span',
            {
                // eslint-disable-next-line react/no-array-index-key
                key: i
                // Part is highlighted if it matches highlightText (case insensitive)
                , className: part.match(new RegExp(escapedHighlightText, 'gi')) ? _suggestion2.default.highlighted : null
            },
            part
        );
    });
};

var Suggestion = function (_React$Component) {
    _inherits(Suggestion, _React$Component);

    function Suggestion() {
        _classCallCheck(this, Suggestion);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    Suggestion.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.highlightIndex !== this.props.highlightIndex && this.props.index === this.props.highlightIndex) {
            this.props.setResultSelection(this.props.result.label);
        }
    };

    Suggestion.prototype.render = function render() {
        var _this2 = this;

        return _react2.default.createElement(
            _genericResult2.default,
            {
                onClick: function onClick() {
                    _this2.props.onClick(_this2.props.result.label);
                },
                index: this.props.index,
                highlightIndex: this.props.highlightIndex,
                getContainerRect: this.props.getContainerRect,
                scrollIntoView: this.props.scrollIntoView
            },
            _react2.default.createElement(
                'div',
                { className: _suggestion2.default.icon },
                _react2.default.createElement(_SVGIcon2.default, {
                    type: SUGGESTION_ICON[this.props.result.source],
                    width: _suggestion2.default.iconSize,
                    fill: _suggestion2.default.iconColor
                })
            ),
            _react2.default.createElement(
                'span',
                { className: _suggestion2.default.content },
                this.props.savedQuery ? renderLabelWithHighlightedText(this.props.result.label, this.props.savedQuery) : this.props.result.label
            )
        );
    };

    return Suggestion;
}(_react2.default.Component);

exports.default = Suggestion;


Suggestion.propTypes = propTypes;
Suggestion.defaultProps = defaultProps;